import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { Helmet } from "react-helmet";

import Header from "../Components/Header";
import Footer from "../Components/Footer";

const Section = ({ title, children }) => (
  <Box mb={4}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Typography color="text.secondary" lineHeight={1.8}>
      {children}
    </Typography>
  </Box>
);

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy – GroHair & GloSkin</title>
        <meta
          name="description"
          content="Read GroHair & GloSkin's Privacy Policy to understand how we collect, use, and protect your personal information."
        />
      </Helmet>

      <Header />

      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 8, lg: 12 },
          py: 6,
          mt: { xs: 10, md: 10 },
          bgcolor: "#fff",
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography color="text.secondary" mb={4}>
          Last updated: 29 August 2026
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Section title="1. Introduction">
          GroHair & GloSkin ("we", "us", "our") is committed to protecting
          your privacy. This Privacy Policy explains how we collect, use,
          disclose, and safeguard your information when you visit our
          website or use our services.
        </Section>

        <Section title="2. Information We Collect">
          We may collect personal information such as your name, phone
          number, email address, and appointment details when you book a
          consultation, fill out a contact form, or communicate with us. We
          may also automatically collect technical information such as your
          IP address, browser type, and pages visited through cookies and
          similar technologies.
        </Section>

        <Section title="3. How We Use Your Information">
          We use the information we collect to schedule and manage
          appointments, respond to enquiries, send appointment reminders and
          service updates, improve our website and services, and comply with
          legal obligations.
        </Section>

        <Section title="4. Sharing of Information">
          We do not sell your personal information. We may share information
          with trusted third parties such as scheduling and communication
          service providers who assist us in operating our website and
          business, and only to the extent necessary to provide their
          services to us.
        </Section>

        <Section title="5. Data Security">
          We implement reasonable administrative, technical, and physical
          safeguards to protect your personal information. However, no
          method of transmission over the internet is completely secure, and
          we cannot guarantee absolute security.
        </Section>

        <Section title="6. Your Rights">
          You may request access to, correction of, or deletion of your
          personal information by contacting us using the details below. You
          may also withdraw consent for us to contact you at any time.
        </Section>

        <Section title="7. Cookies">
          Our website uses cookies to improve your browsing experience. For
          more details, please see our Cookie Policy.
        </Section>

        <Section title="8. Changes to This Policy">
          We may update this Privacy Policy from time to time. Any changes
          will be posted on this page with an updated revision date.
        </Section>

        <Section title="9. Contact Us">
          If you have questions about this Privacy Policy, please contact us
          at Kanchipuram@adgrohair.com or call +91 097510 56789. Address: 1st
          Floor, KTS Towers, Nellukara St, above Federal Bank, Kanchipuram,
          Tamil Nadu 631502.
        </Section>
      </Box>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
